export default __webpack_public_path__ + "static/media/high-icon-3.1633c707.png";